import { render, staticRenderFns } from "./Course-Type.vue?vue&type=template&id=2b73e212&scoped=true"
import script from "./Course-Type.vue?vue&type=script&lang=js"
export * from "./Course-Type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b73e212",
  null
  
)

export default component.exports